export default __webpack_public_path__ + "static/media/197.dbc75e5f.png";